export enum CancelReasonEnum {
    MINIUM_TICKETS_NOT_RESERVED,
    RAFFLE_CANCELLED,
    BENEFICIARY_RAFFLE_CANCEL
  }
  